import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/section.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

function ExistingModels() {
    return (
        <div className="section-container">
            <Header />
            <main className="section-content">
                <p className="section-intro-paragraph">Learn about popular models here</p>
                <div className="subsection-links">
                    <Link to="/existingmodels/bert">BERT & Its Variants</Link>
                    <Link to="/existingmodels/generativepretrained">Generative Pre-trained Transformers</Link>
                    <Link to="/existingmodels/advancedexisting">Alternatives & Advanced Models</Link>
                    <Link to="/existingmodels/zeroshot">Zero-shot, Few-shot, Many-shot</Link>
                    <Link to="/existingmodels/huggingface">Hugging Face</Link>
                </div>
            </main>
            <Footer />
        </div>
    );
}

export default ExistingModels;